<app-panda-party title="{{title}}" 
                 src="{{randomSource}}" 
                 subtitle="{{subtitle}}">
</app-panda-party>